<!-- eslint-disable -->
<script setup>
import { ref, computed, onMounted, onUnmounted, watch }  from 'vue';
import { useRouter, useRoute } from 'vue-router';

import { useCustomerStore } from '@/stores/customer';
import { useCurrenciesStore } from '@/stores/currencies';
import { useDatesStore } from '@/stores/dates';
import { useGeneralStore } from '@/stores/general';

import { openModal } from '@kolirt/vue-modal';
import { useI18n } from 'vue-i18n';
import Login from '../modals/Login.vue';
import TabNav from './tabNav.vue';
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import SettingDropdown from './settingDropdown.vue'
import LanguageChangeMobile from '../Common/LanguageChange.vue';
import OddSelectorMobile from '../Common/OddSelector.vue';
import SettingOddsMobile from '../Common/SettingOdds.vue';
import UserDropdown from './userDropdown.vue'
import Register from '../modals/Register.vue';
import SportsbookSearch from '../modals/SportsbookSearch.vue';
import { useNavbarStore } from '@/stores/navbar_items';
import { BetSlip } from '@/stores/BetSlip';
import { useMenuStore } from '@/stores/menus';
import { useRacingSportsStore } from '@/stores/racing_sports';
import NotificationsDropdown from '@/components/Common/notificationsDropdown.vue';
import { useSharedBetslipsStore } from '@/stores/shared_betslips';
import SharedBetslipError from '@/components/modals/SharedBetslipError.vue';
import { usePreSportsStore } from '@/stores/pre_sports';
import AccountMobileDashboard from '@/components/account/account_mobile/AccountMobile.vue'
import { useMobileDashboardPrevious } from "@/stores/mobile_dashboard_previous_route"
import { useInitializeStore } from '@/stores/initialize';
import PlatformNotification from './PlatformNotification.vue';
import LiveChatHeader from './LiveChatHeader.vue';
import { useThemeStore } from '@/stores/themes';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import { useAgentStore } from '@/stores/agent';
import ThemeSwitcher from '@/components/Common/ThemeSwitcher.vue';

const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const customerStore = useCustomerStore();
const menuStore = useMenuStore();
const currenciesStore = useCurrenciesStore();
const datesStore = useDatesStore();
const generalStore = useGeneralStore();
const navbarStore = useNavbarStore();
const betslipStore = BetSlip();
const racingSportsStore = useRacingSportsStore();
const sharedBetslipStore = useSharedBetslipsStore();
const preSportsStore = usePreSportsStore();
const mobileDashboardStore = useMobileDashboardPrevious();
const platformConfigurationStore = usePlatformConfigurationStore();
const agentStore = useAgentStore();
const themeStore = useThemeStore();
const initializeStore = useInitializeStore();

const openChat = () => {
	const y = window.scrollY || window.pageYOffset || 0;
	document.activeElement?.blur?.();

	platformConfigurationStore.openLiveChat();

	if (window.Tawk_API) {
		requestAnimationFrame(() => {
			const body = document.body;
			const html = document.documentElement;
			['position', 'top', 'left', 'right', 'width', 'height', 'min-height', 'max-height', 'max-width', 'overflow']
				.forEach(prop => body.style.removeProperty(prop));
			html.style.removeProperty('overflow');
			if (location.hash === '#max-widget') {
				history.replaceState(null, document.title, location.pathname + location.search);
			}
			window.scrollTo(0, y);
		});
	}
};

const svgs_data = commonSvgs;
const screenWidth = ref(window.innerWidth);
const shared_betslip_code = ref(null);
const button_disabled = ref(true);
const platform_notification_product = ref(null);

const tooltipText = computed(() => {
	if (!customerStore.verificationDaysLeft) return '';

	const { days, type, datetime } = customerStore.verificationDaysLeft;

	if (days === -1 || days <= 0) {
		return t('account.verification_process.you_must_verify_your_account');
	}

	const expireDate = datesStore.defaultDate(datetime);
	const willExpireAt = t('account.verification_process.your_account_will_expire_at');

	if (type === 'email') {
		if (days === 1) {
			return `${t('account.verification_process.day_left_to_verify_email')} ${willExpireAt} ${expireDate}`;
		}
		return `${t('account.verification_process.days_left_to_verify_email', { days })} ${willExpireAt} ${expireDate}`;
	} else if (type === 'documents') {
		if (days === 1) {
			return `${t('account.verification_process.day_left_to_verify_documents')} ${willExpireAt} ${expireDate}`;
		}
		return `${t('account.verification_process.days_left_to_verify_documents', { days })} ${willExpireAt} ${expireDate}`;
	}

	return '';
});

const showLoginModal = () => {
	openModal(Login).then((data) => {
		if (data.show_register) showRegisterModal();
	}).catch(() =>{});
};

const showRegisterModal = () => {
	openModal(Register).then((data) => {
		if (data.show_login) showLoginModal();
	}).catch(() =>{});
};

const activeTab = ref(null);

const setActiveTab = (tab) => {
	if (activeTab.value === tab) {
		activeTab.value = null; // Close the tab if it's already active
	} else {
		activeTab.value = tab; // Open the tab
	}
};

const closeTab = (tab) => {
	if (activeTab.value === tab) {
		activeTab.value = null; // Close the tab on double-click
	}
};


const isDashboardActive = ref(false);

const setDashboardActive = () => {
	isDashboardActive.value = true;
};

const closeDashboard = (event) => {
  event.stopPropagation();  // Prevents triggering the setDashboardActive when closing
  isDashboardActive.value = false;
};
watch(isDashboardActive, (isActive) => {
	const updateClass = () => {
		if (window.innerWidth < 768 && isActive) {
		document.body.classList.add('dashboardMobile-active');
		} else {
		document.body.classList.remove('dashboardMobile-active');
		}
	};

	// Initial check when the watcher is triggered
	updateClass();

	// Add resize event listener
	window.addEventListener('resize', () => {
		if (window.innerWidth >= 768) {
		document.body.classList.remove('dashboardMobile-active');
		} else {
		if (isActive) {
			document.body.classList.add('dashboardMobile-active');
		} else {
			document.body.classList.remove('dashboardMobile-active'); // Ensure it's removed if isActive is false
		}
		}
	});

	// Clean up the event listener on watcher destroy
	return () => {
		window.removeEventListener('resize', updateClass);
	};
});

const toggleBalanceVisibility = () => {
	if (customerStore.balance_visibility == true) customerStore.balance_visibility = false;
	else customerStore.balance_visibility = true;
};

const showSportsbookSearchModal = (event) => {
	event.stopPropagation();
	openModal(SportsbookSearch).catch(() => {});
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
	navbarStore.user_dropdown_opened = false;
	navbarStore.settings_dropdown = false;
	navbarStore.mobile_menu = false;
	navbarStore.notifications_dropdown = false;
};

const showSettings = () => {
	navbarStore.settings_dropdown = !navbarStore.settings_dropdown;
	navbarStore.user_dropdown_opened = false;
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
	navbarStore.mobile_menu = false;
	navbarStore.notifications_dropdown = false;
}

const showUserDropdown = () => {
	navbarStore.user_dropdown_opened = !navbarStore.user_dropdown_opened;
	navbarStore.settings_dropdown = false;
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
	navbarStore.mobile_menu = false;
	navbarStore.notifications_dropdown = false;
}

const showNotificationsDropdown = () => {
	navbarStore.notifications_dropdown = !navbarStore.notifications_dropdown;
	navbarStore.user_dropdown_opened = false;
	navbarStore.settings_dropdown = false;
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
	navbarStore.mobile_menu = false;
	if (navbarStore.notifications_dropdown) {
		customerStore.markAsReadDropdownNotifications().then((response) => {
			customerStore.fetchCustomerDropdownNotifications();
		})
	}
}

const showNotificationsDropdownMobile = () => {
	navbarStore.notifications_dropdownMobile = !navbarStore.notifications_dropdownMobile;
	navbarStore.user_dropdown_opened = false;
	navbarStore.settings_dropdown = false;
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
	navbarStore.mobile_menu = false;
	if (navbarStore.notifications_dropdownMobile) {
		customerStore.markAsReadDropdownNotifications().then((response) => {
			customerStore.fetchCustomerDropdownNotifications();
		})
	}
}

const toggleMobileMenu = () => {
	navbarStore.mobile_menu = !navbarStore.mobile_menu;
	navbarStore.closeAll()
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
}

const getUrlHeader = (data) => {
	if (data.click_url == '#/pre-sports' || data.click_url == '/pre-sports') {
		return { name: 'pre-sports-coupons', params: {sport_id: preSportsStore.preSports[0]?.id}}
	} else if (data.click_url == '#/live-sports' || data.click_url == '/live-sports') {
		return { name: 'live-sports-overview', params: { sport_id: '' } };
	} else if (data.click_url == null && data.static_page_url) {
		return data.static_page_url
	} else if (data.click_url && data.click_url.startsWith('http')) {
		return data.click_url;
	} else if (data.click_url && data.click_url.startsWith('#/')) {
		return data.click_url.replace('#/', '/');
	} else if (data.click_url && data.click_url.startsWith('/')) {
		return data.click_url;
	} else if (data.click_url) {
		return data.click_url;
	}
}

const getUrl = (menu_child) => {
	if (!menu_child.click_url && !menu_child.static_page_url) return false
	if (menu_child.click_url == '#/promotions/all') return menu_child.click_url.replace('#', '').replace('/all', '');
	if (menu_child.click_url && menu_child.click_url.startsWith('#')) return menu_child.click_url.replace('#', '');
	else if (menu_child.click_url && menu_child.click_url.startsWith('http')) return menu_child.click_url
	else if (menu_child.click_url && menu_child.click_url.startsWith('/')) return menu_child.click_url
	else if (menu_child.static_page_url) return menu_child.static_page_url;
}

const isRouteActive = (data) => {
	const is_bet_boosts_route = route.name === 'pre-sports-bet-boosts' || (route.path && route.path.includes('bet-boosts'));
	const is_bet_boosts_menu = Boolean(data.click_url && data.click_url.includes('bet-boosts'));

	if (is_bet_boosts_route) return is_bet_boosts_menu;
	if (is_bet_boosts_menu) return false;

	if (data.click_url && data.click_url.includes('pre-sports') && route.path && route.path.includes('pre-sports')) return true;

	if (route.path.includes('/casino/game')) {
		// If there is a menu for this exact game (click_url == route.path)
		let menu_item = _.find(menuStore.getHeaderMenus, { 'click_url': route.path });
		if (menu_item) {
			// Don't highlight the main Casino menu when on a direct game link that is in the menu
			if (data.click_url == '/casino') return false;
		} else {
			// Otherwise, highlight the main Casino menu if we're on a casino game page and no specific game menu exists
			if (data.click_url == '/casino') return true;
		}
	}

	// Detect if current menu is the default casino
	if (data.click_url === '/casino') {
		const is_default_casino = ((route.path === '/casino' || route.path.startsWith('/casino/')) && !route.params.custom_page_slug);

		return is_default_casino;
	}

	// Custom page casino
	if (route.params.custom_page_slug && data.click_url === `/${route.params.custom_page_slug}`) {
		const is_custom_page = (route.path === `/${route.params.custom_page_slug}` ||	route.path.startsWith(`/${route.params.custom_page_slug}/`));

		return is_custom_page;
	}

	if (data.click_url) {
		return route.path.startsWith(data.click_url);
	} else return route.path == data.static_page_url

};

const goToRacingSports = () => {
	// must get frist racing sport from getter and navigate there
	let first_sport = racingSportsStore.racingSports[0];

	router.push({name: 'racing-coupons', params: {sport_id: first_sport.id}});
	racingSportsStore.setSelectedRacingSportId(first_sport.id);
	toggleMobileMenu();
}

const goToESports = () => {
	let first_sport = preSportsStore.esports[0];

	router.push({name: 'esports-upcoming', params: {sport_id: first_sport.id}});
	preSportsStore.setSelectedEsportId(first_sport.id);
	toggleMobileMenu();
}

const clickOutsideUserDropdown = (event) => {
	const isSVGElement = event.target instanceof SVGElement || event.target.parentNode instanceof SVGElement;

	const userDropdown = document.getElementById('navbarStore.user_dropdown_opened');

	if (userDropdown && !userDropdown.contains(event.target) && !isSVGElement) {
		navbarStore.user_dropdown_opened = false;
	}
};

const clickOutsideMenu = (event) => {
	const mobileMenu = document.getElementById('mobile-menu');
	if (mobileMenu && !mobileMenu.contains(event.target)) {
		navbarStore.mobile_menu = false;
	}
};

const clickOutsideSettings = (event) => {
	const settings = document.getElementById('settings-dropdown');

	if (settings && !settings.contains(event.target)) {
		navbarStore.settings_dropdown = false;
	}
};

const clickOutsideNotifications = (event) => {
	const notifications = document.getElementById('notifications-dropdown');

	if (notifications && !notifications.contains(event.target)) {
		navbarStore.notifications_dropdown = false;
	}
};

const updateScreenWidth = () => {
	screenWidth.value = window.innerWidth;
}

watch(() => shared_betslip_code.value, (newValue, oldValue) => {
	if (newValue != '' && newValue != null) button_disabled.value = false;
	else if (newValue == '' || newValue == null) button_disabled.value = true;
})

const fetchSharedBetslip = () => {
	if (shared_betslip_code.value == null && shared_betslip_code.value == '') return

	navbarStore.mobile_menu = false;

	sharedBetslipStore.fetchSharedBetslip(shared_betslip_code.value).then((response) => {
		betslipStore.resetBetslip();

		let bets = JSON.parse(response.bets)
		let shared_id = shared_betslip_code.value
		let id = response.id;

		let must_delete = false;

		for (let index in bets) {
			let bet = bets[index];

			betslipStore.toggleToBetslip({ odd_uuid: bet.bet_uuid, fixture_id: bet.fixture_id }, shared_id, id).catch(error => {
				if (!must_delete) {
					// sharedBetslipStore.deleteSharedBetslip(shared_id, false);
					must_delete = true;
				}
			});
		}

		shared_betslip_code.value = null;

	}).catch((error) => {
		if (error.response.status == 429) return;
		openModal(SharedBetslipError, {errors: error.response, need_redirect: false}).catch(() =>{});
	})
}
// Add a watcher to add/remove a class on the body element based on navbarStore.mobile_menu
watch(() => navbarStore.mobile_menu, (newValue) => {
	if (newValue) {
		document.body.classList.add('mobile-menu-active');
		let mini_layer = document.getElementById('mini-betslip-layer');
		if (mini_layer) {
			mini_layer.classList.add('hidden');
		}

	} else {
		document.body.classList.remove('mobile-menu-active');
		let mini_layer = document.getElementById('mini-betslip-layer');
		if (mini_layer) {
			mini_layer.classList.remove('hidden');
		}

	}
});

const platform_notification = computed(() => {
	if (!platform_notification_product.value) return [];

	if (platform_notification_product.value.includes('pre-sports') || platform_notification_product.value.includes('live-sports') || platform_notification_product.value.includes('esports') || platform_notification_product.value.includes('racing')) {
		return customerStore.customerSportsbookPlatformNotifications
	} else if (platform_notification_product.value.includes('live-casino')) {
		return customerStore.customerLiveCasinoPlatformNotifications
	} else if (platform_notification_product.value.includes('casino')) {
		return customerStore.customerCasinoPlatformNotifications
	} else return customerStore.customerGeneralPlatformNotifications;
});

const showSettingsTab = computed(() => {
	const is_theme_switcher_visible = platformConfigurationStore.isMultiThemeSupportEnabled && themeStore.themes.length > 1;
	return customerStore.isLoggedIn || is_theme_switcher_visible
})

const showThemeSwitcher = computed(() => {
	if (Array.isArray(themeStore.themes) && themeStore.themes.length == 2) {
		if (platformConfigurationStore.showThemeSwitchIconOnMobileHeader) return true;
		else if (screenWidth.value > 1150) return true;
		else return false;
	} else {
		return false;
	}
})

onMounted(() => {
	platform_notification_product.value = router.currentRoute.value.path;

	window.addEventListener("resize", () => {
		updateScreenWidth();
	});
	document.addEventListener('click', clickOutsideUserDropdown);
	document.addEventListener('click', clickOutsideSettings);
	document.addEventListener('click', clickOutsideNotifications);

	document.addEventListener('click', clickOutsideMenu);

	const previous_route_data = mobileDashboardStore.getMobileDashboardPrevious;
	if(previous_route_data?.name  && previous_route_data?.name === router.currentRoute.value.name){
		isDashboardActive.value = true;
		mobileDashboardStore.setMobileDashboardPrevious(null)
	}
	else{
		document.body.classList.remove('dashboardMobile-active');
	}
})

onUnmounted(() => {
	window.removeEventListener("resize", null);
	document.removeEventListener('click', clickOutsideUserDropdown);
	document.removeEventListener('click', clickOutsideSettings);
	document.removeEventListener('click', clickOutsideNotifications);
	document.addEventListener('click', clickOutsideMenu);
});
</script>
<template>
	<header class="header-inner-page dark-header modal-vue" :class="customerStore.isLoggedIn ? 'Logged-in logged-in-inner' : ''">
		<div class="container-full header-inner">
			<div class="header-left">
				<div class="logo logo-desktop">
					<router-link to="/">
						<!-- <a><img class="logo-img" style="max-width:130px;" :src="menuStore.isMobile != true ? generalStore.getGeneral.header_logo : generalStore.getGeneral.header_logo_mobile" alt=""></a> -->
						<img class="logo-img" style="max-height: 32px;" :src="generalStore.getGeneral.header_logo" alt="logo-desktop">
					</router-link>
				</div>
				<div class="logo logo-mobile">
					<router-link to="/">
						<!-- <a href="#"><img class="logo-img" style="max-width: 130px;" :src="menuStore.isMobile != true ? generalStore.getGeneral.header_logo : generalStore.getGeneral.header_logo_mobile" alt=""></a> -->
						<img class="logo-img" :src="generalStore.getGeneral.header_logo_mobile" alt="logo-desktop">
					</router-link>
				</div>
				<!-- Desktop nav bar -->
				<nav class="menu-desktop" v-if="menuStore.getHeaderMenus">
					<ul class="nav-list">
						<li v-for="(data, index) in menuStore.getHeaderMenus" :key="index">
							<template v-if="data.children && data.children.length > 0">
								<div class="dropdown">

									<ul class="dropdown-menu">
										<li v-for="(child, i) in data.children" :key="i" :class="$route.path == getUrl(child) ? 'active' : ''">
											<a :href="getUrl(child)">{{ child.name }}</a>
										</li>
									</ul>
								</div>
							</template>
							<template v-else>

								<li v-if="data.click_url && data.click_url.startsWith('http')" :class="isRouteActive(data) ? 'active' : ''">
									<a :href="getUrlHeader(data)">{{ data.name }}</a>
								</li>
								<li v-else-if="data.click_url && data.click_url == '/esports' && preSportsStore.esports.length > 0" :class="isRouteActive(data) ? 'active' : ''">
									<a @click="goToESports" style="cursor: pointer">{{ data.name }}</a>
								</li>
								<li v-else-if="data.click_url && data.click_url == '/racing' && racingSportsStore.racingSports.length > 0" :class="isRouteActive(data) ? 'active' : ''">
									<a style="cursor:pointer;" @click="goToRacingSports">{{ data.name }}</a>
								</li>
								<li v-else :class="isRouteActive(data) ? 'active' : ''">
									<router-link :to="getUrlHeader(data)">{{ data.name }}</router-link>
								</li>
							</template>
						</li>
					</ul>
				</nav>
				<!-- Mobile navbar -->
				<nav class="menu-mobile" id="mobile-menu">
					<div class="nav-mobile"  @click="toggleMobileMenu()">
						<a id="nav-toggle" href="javascript:void(0);" :class="navbarStore.mobile_menu == true ? 'active' : ''"><span></span></a>
					</div>
					<Transition name="slide-fade">
						<div class="nav-list" v-if="navbarStore.mobile_menu">
							<template v-if="menuStore.getHeaderMenus || menuStore.getStaticPageMenu">
								<!-- <ul class="nav-list-inner">
									<div class="first-menu">
										<li v-for="(data, index) in menuStore.getHeaderMenus" :key="index">
											<div v-if="data.children && data.children.length > 0">
												<h6>{{data.name}}</h6>
												<li v-for="(child, i) in data.children" :key="i">
												<a :href="getUrl(child)">{{child.name}}</a>
												</li>
											</div>
											<div v-else>
												<li v-if="data.click_url && data.click_url.startsWith('http')">
													<a :href="data.click_url" class="basic-menu-font" @click="toggleMobileMenu">{{ data.name }}</a>
												</li>
												<li v-else-if="data.click_url && data.click_url == '/esports' && preSportsStore.esports.length > 0">
													<a @click="goToESports" style="cursor: pointer">{{ data.name }}</a>
												</li>
												<li v-else-if="data.click_url && data.click_url == '/racing' && racingSportsStore.racingSports.length > 0">
													<a style="cursor:pointer;" @click="goToRacingSports">{{ data.name }}</a>
												</li>
												<li :class="data.media_url ? 'icon': ''" v-else>
													<img v-if="data.media_url" :src="data.media_url" class="header-mobile-icon">
													<router-link v-if="data.click_url != '/live-chat'" :to="getUrlHeader(data)" class="basic-menu-font" @click="toggleMobileMenu">{{ data.name }}</router-link>
												</li>
											</div>
										</li>
									</div>
									<div class="second-menu">
										<template v-for="(data, index) in menuStore.getHeaderMenus" :key="index">
											<li v-if="data.click_url == '/live-chat'">
												<a href="javascript:void(0);" @click.prevent="openChat" class="custom-font">{{ data.name }}<i class="fas fa-comments"></i></a>
											</li>
										</template >
										<li>
											<a href="#" class="custom-font">{{ $t('general.download_the_app') }} <i class="fas fa-download"></i></a>
										</li>
									</div>

									<div class="third-menu">
										<div v-for="(data, index) in menuStore.getStaticPageMenu" :key="index">
											<div v-if="data.children && data.children.length > 0">
												<h6>{{data.name}}</h6>
												<li v-for="(child, i) in data.children" :key="i">
												<a :href="getUrl(child)">{{child.name}}</a>
												</li>
											</div>
											<div v-else>
												<li>
												<a :href="getUrl(data)"> {{ data.name }} </a>
												</li>
											</div>
										</div>
									</div>
									<div class="bottom-menu">
										<div class="text-field">
											<input type="text" class="form-input" v-model="shared_betslip_code" :placeholder="$t('general.type_shared_bet_code')">
											<a @click="shared_betslip_code = null"><i class="fa fa-times-circle clear-button" aria-hidden="true"></i></a>
										</div>
										<button class="share-btn" :class="{'btn-disabled': button_disabled}" type="button" @click="fetchSharedBetslip()">
											<i class="fa fa-plus" aria-hidden="true" style="margin-right: 2px;"></i>&nbsp;{{ $t('general.add_bets') }}
										</button>
									</div>
								</ul> -->
								<div class="mobile-menu-top">
									<!-- menu top tabing start -->
									<div class="mobile-menu-tab">
										<div class="tab">
											<button class="tablinks" :class="activeTab=='language'?'active':''" @click="setActiveTab('language')" @dblclick="closeTab('language')"><img src="@/assets/images/lang-ico.svg" alt="Lang Icon">{{ $t('account.account_preferences.language') }}</button>
											<button class="tablinks" :class="activeTab=='odds'?'active':''" @click="setActiveTab('odds')" @dblclick="closeTab('odds')"><img src="@/assets/images/odd-ico.svg" alt="odd Icon">{{ $t('general.odds_format') }}</button>
											<button v-if="showSettingsTab" class="tablinks" :class="activeTab=='setting'?'active':''" @click="setActiveTab('setting')" @dblclick="closeTab('setting')"><img src="@/assets/images/setting-ico.svg" alt="setting Icon">{{ $t('general.settings') }}</button>
										</div>
										<div class="tabing-content">
											<!-- language tab content start -->
											<div id="language" class="tab-content" :class="activeTab=='language'?'active':''">
												<div class="menu-back-option">
													<div class="menu-back-inner" @click="closeTab('language')">
														<object v-html="commonSvgs.arrow_left"></object>
														<p>{{ $t('general.menu') }}</p>
													</div>
												</div>
												<LanguageChangeMobile></LanguageChangeMobile>
											</div>
											<!-- language tab content end -->


											<!-- odds tab content start -->
											<div id="odds" class="tab-content" :class="activeTab=='odds'?'active':''">
												<div class="menu-back-option">
													<div class="menu-back-inner" @click="closeTab('odds')">
														<object v-html="commonSvgs.arrow_left"></object>
														<p>{{ $t('general.menu') }}</p>
													</div>
												</div>
												<OddSelectorMobile></OddSelectorMobile>
											</div>
											<!-- odds tab content end -->

											<!-- setting tab content start -->
											<div id="setting" class="tab-content" :class="activeTab=='setting'?'active':''">
												<div class="menu-back-option">
													<div class="menu-back-inner" @click="closeTab('setting')">
														<object v-html="commonSvgs.arrow_left"></object>
														<p>{{ $t('general.menu') }}</p>
													</div>
												</div>
												<SettingOddsMobile></SettingOddsMobile>
											</div>
											<!-- setting tab content end -->
										</div>
									</div>

									<!-- menu top tabing end -->

									<!-- menu scroll area start -->
									<div class="mobile-top-area" :style="{'height': initializeStore.isAppleMobile ? 'calc(100vh - 410px)' : ''}">
										<div class="mobile-main-menu">
											<div class="mobile-menu-items" >
												<div class="mobile-menu-item-inner" v-for="(data, index) in menuStore.getHeaderMenus" :key="index" >
													<template v-if="data.children && data.children.length > 0">
													<div class="mobile-item-inner" v-for="(child, i) in data.children" :key="i" @click="getUrl(child)" :class="isRouteActive(data) ? 'active' : ''">
														<div class="menu-icons-outer">
														<object class="white-ico" v-html="commonSvgs.sports_ico"></object>
														<object class="green-ico" v-html="commonSvgs.Green_sports_ico"></object>
														</div>
														<p>{{ child.name }}</p>
													</div>
													</template>
													<template v-else>
													<div class="mobile-item-inner" v-if="data.click_url && data.click_url.startsWith('http')"  @click="toggleMobileMenu" :class="isRouteActive(data) ? 'active' : ''">
														<a :href="data.click_url">
															<div class="menu-icons-outer" style="margin-right: 10px;">
																<object class="white-ico" v-html="commonSvgs.sports_ico"></object>
																<object class="green-ico" v-html="commonSvgs.Green_sports_ico"></object>
															</div>
															<p>{{ data.name }}</p>
														</a>
													</div>
													<div class="mobile-item-inner" v-else-if="data.click_url === '/esports' && preSportsStore.esports.length > 0" @click="goToESports" :class="isRouteActive(data) ? 'active' : ''">
														<div class="menu-icons-outer">
														<object class="white-ico" v-html="commonSvgs.sports_ico"></object>
														<object class="green-ico" v-html="commonSvgs.Green_sports_ico"></object>
														</div>
														<p>{{ data.name }}</p>
													</div>
													<div class="mobile-item-inner" v-else-if="data.click_url === '/racing' && racingSportsStore.racingSports.length > 0" @click="goToRacingSports" :class="isRouteActive(data) ? 'active' : ''">
														<div class="menu-icons-outer">
															<object class="white-ico" v-html="commonSvgs.horse_r_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_horse_r_ico"></object>
														</div>
														<p>{{ data.name }}</p>
													</div>
													<div class="mobile-item-inner" v-else :class="isRouteActive(data) ? 'active' : ''">
														<div class="menu-icons-outer" :class="{ 'icon': data.media_url }">
														<template v-if="data.click_url == '/pre-sports'">
															<object class="white-ico" v-html="commonSvgs.sports_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_sports_ico"></object>
														</template>
														<template v-if="data.click_url == '/live-sports'">
															<object class="white-ico" v-html="commonSvgs.live_badge_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_live_badge_ico"></object>
														</template>
														<template v-if="data.click_url == '/live-casino'">
															<object class="white-ico" v-html="commonSvgs.casino_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_casino_ico"></object>
														</template>
														<template v-if="data.click_url == '/casino'">
															<object class="white-ico" v-html="commonSvgs.dice_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_dice_ico"></object>
														</template>
														<template v-if="data.click_url == '/promotions'">
															<object class="white-ico" v-html="commonSvgs.gift_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_gift_ico"></object>
														</template>
														<template v-if="data.click_url == '/aviator'">
															<object class="white-ico" v-html="commonSvgs.aviator_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_aviator_ico"></object>
														</template>
														<template v-if="data.click_url == '/horse-racing'">
															<object class="white-ico" v-html="commonSvgs.horse_r_ico"></object>
															<object class="green-ico" v-html="commonSvgs.Green_horse_r_ico"></object>
														</template>
														<template v-if="data.media_url">
															<img :src="data.media_url" style='max-width:35px;'>
														</template>
														</div>
														<router-link v-if="data.click_url !== '/live-chat'" :to="getUrlHeader(data)" class="basic-menu-font" @click="toggleMobileMenu">
															<p>{{ data.name }}</p>
														</router-link>
													</div>
													</template>
												</div>

											</div>
										</div>

										<div class="useful-links-main">
											<h3>{{ $t('general.useful_links') }}</h3>
											<div class="useful-links-inner" >
												<div class="useful-item-main" v-for="(data, index) in menuStore.getStaticPageMenu" :key="index" :class="isRouteActive(data) ? 'active' : ''">
													<div v-if="data.children && data.children.length > 0" class="useful-links-item">
														<p><a :href="getUrl(link)">{{link.name}}</a></p>
													</div>
													<div v-else class="useful-links-item" :class="isRouteActive(data) ? 'active' : ''">
														<p><a :href="getUrl(data)"> {{ data.name }} </a></p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- menu scroll area end -->

									<!-- share predicton start -->
									<div class="share-prediction-bottom">
										<div class="share-prediction-inner">
											<h3>{{ $t('general.Share_your_predictions') }}</h3>
											<form @submit.prevent>
												<div class="fieldset">
													<input type="text" name="fullname"  class="form-text" v-model="shared_betslip_code" :placeholder="$t('general.type_shared_bet_code')">
													<span @click="shared_betslip_code = null" class="clear-text"><object v-html="commonSvgs.close"></object></span>
												</div>
												<button :class="{'btn-disabled': button_disabled}" class="btn-small btn-secondary" @click="fetchSharedBetslip()">{{ $t('general.add_bets') }}</button>
											</form>
										</div>
									</div>
									<!-- share predicton end -->
								</div>
							</template>
						</div>
					</Transition>
				</nav>
			</div>

			<!-- search field -->
			<!-- <div class="header-search-field">
				<div class="header-search-inner" @click="showSportsbookSearchModal">
					<input type="search" placeholder="Search for sports, competitions or teams…" :disabled="showModal">
					<button type="button">
						<div v-html="header_icons.search"></div>
					</button>
				</div>
			</div> -->

			<div class="login-info" v-if="customerStore.isLoggedIn">
				<ThemeSwitcher v-if="showThemeSwitcher"></ThemeSwitcher>
				<template v-if="customerStore.verificationDaysLeft">
					<div class="email-verification-icon" v-if="customerStore.verificationDaysLeft.days != -1">
						<div class="email-verification-inner">
							<span>{{ customerStore.verificationDaysLeft.days }}</span>

							<object v-html="svgs_data.calendar"></object>
						</div>
						<div class="tooltip-main bottom">
							<div class="tooltip-inner">
								<p>{{ tooltipText }}</p>
							</div>
						</div>
					</div>

					<div class="email-verification-icon" v-if="customerStore.verificationDaysLeft.days == -1">
						<div class="email-verification-inner">
							<img src="/assets/icons/verification.svg" width="30">
						</div>
						<div class="tooltip-main bottom">
							<div class="tooltip-inner">
								<p>{{ tooltipText }}</p>
							</div>
						</div>
					</div>
				</template>

				<div v-if="!agentStore.isAgentOrAffiliate" class="deposite-btn">
					<router-link v-if="platformConfigurationStore.showWalletButtonInsteadOfDepositInHeader" to="/account/bank/deposits" class="btn-small btn-secondary wallet-btn">
						<div v-html="commonSvgs.wallet_icon" class="wallet-icon"></div>
					</router-link>
					<router-link v-else to="/account/bank/deposits" class="btn-small btn-secondary btn-glowing-border">{{ $t('general.deposit') }}</router-link>
				</div>

				<div v-if="platformConfigurationStore.showNotificationIconOnMobileHeader" class="notification-mobile" @click="showNotificationsDropdownMobile()">
					<a class="notifications-main" id="notifications-dropdownMobile">
						<div class="notification-icon-area">
							<svg class="not-icon"
								xmlns="http://www.w3.org/2000/svg"
								xml:space="preserve"
								version="1.1"
								style="width:28px; fill: none; stroke:var(--header-text-color-active); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
								viewBox="0 0 30 30"
								xmlns:xlink="http://www.w3.org/1999/xlink">
								<use :xlink:href="'/assets/images/notification-icon.svg#svg3108'" stroke-width="1px"  />
							</svg>
							<!-- <object v-html="commonSvgs.notification_popup"></object> -->
							<span v-if="customerStore.getCustomer.unread_notifications_count > 0" class="notification-num">{{ customerStore.getCustomer.unread_notifications_count }}</span>
						</div>
						<div v-if="navbarStore.notifications_dropdownMobile" class="notifications-dropdown-main">
							<NotificationsDropdown v-if="navbarStore.notifications_dropdownMobile"></NotificationsDropdown>
						</div>
					</a>
				</div>

				<LiveChatHeader/>


				<div class="user-profile-top" :class="navbarStore.user_dropdown_opened ? 'active' : ''" id="navbarStore.user_dropdown_opened">
					<div class="mobile-user-ico" @click="setDashboardActive" :class="{ active: isDashboardActive }">
						<!-- <router-link to="/account/account-mobile/account-mobile-dashboard"><img src="@/assets/images/user-ico.svg" alt="user icon"></router-link> -->
						<!-- <img src="@/assets/images/user-ico.svg" alt="user icon"> -->
						<svg class="user-icons"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:25px; fill: none; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 30 25"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="'/assets/images/user-ico.svg#svg3108'" stroke-width="1px"  />
						</svg>
					</div>
					<div class="accountDashboardMobile" v-if="isDashboardActive">
						<div class="dashboard-mobile-top">
							<div></div>
							<div class="dashboard-title">
								<h6><img src="@/assets/images/user-ico.svg" alt="user icon">{{ customerStore.getCustomer.username }}</h6>
							</div>
							<div class="close-btn" @click="closeDashboard">
								<object v-html="commonSvgs.close"></object>
							</div>
						</div>
						<AccountMobileDashboard ></AccountMobileDashboard>
					</div>

					<div class="user-detail" @click="showUserDropdown()">
						<p class="customer-username" style="margin-right: 5px;">{{ customerStore.getCustomer.username }} </p>
						<!-- <img src="@/assets/images/user-ico.svg" class="user-icon" alt="user icon"> -->
						<svg class="user-icons"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:25px; fill: none; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 30 25"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="'/assets/images/user-ico.svg#svg3108'" stroke-width="1px"  />
						</svg>
					</div>

					<UserDropdown></UserDropdown>
				</div>

				<div class="profile-balance" @click="setDashboardActive">
					<p>{{ $t('general.balance') }}</p>
					<h6 v-if="customerStore.balance_visibility == true">{{ currenciesStore.format_currency(customerStore.getCustomer.balance.combined_balance, customerStore.getCustomer.currency.code) }}</h6>
					<h6 v-else>*********</h6>
				</div>
				<div class="icon desktop-only">
					<svg v-if="customerStore.balance_visibility == true" @click="toggleBalanceVisibility()" class="user-icons"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:15.414; height:15.414; fill: none; shape-rendering:geometricPrecision; cursor: pointer; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 24 24"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="'/assets/images/eye.svg#svg3108'" stroke-width="1px"  />
					</svg>
					<svg v-else @click="toggleBalanceVisibility()" class="user-icons"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:15.414; height:15.414; fill: none; shape-rendering:geometricPrecision; cursor: pointer; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 15.414 15.414"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="'/assets/images/Icon_feather-eye-off.svg#svg3108'" stroke-width="1px"  />
					</svg>
					<!-- <img v-if="customerStore.balance_visibility == true" @click="toggleBalanceVisibility()" src="/assets/images/eye.svg" alt style="cursor: pointer" />
					<img v-else @click="toggleBalanceVisibility()" src="/assets/images/Icon_feather-eye-off.svg" alt style="cursor: pointer" /> -->
				</div>

				<div class="header-icon">
					<div  @click="showNotificationsDropdown()" class="notifications-main" id="notifications-dropdown" style="cursor: pointer; top: 3px;left: 3px;">
						<span v-if="customerStore.getCustomer.unread_notifications_count > 0" class="notification-num">{{ customerStore.getCustomer.unread_notifications_count }}</span>
						<svg class="not-icon"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:28px; fill: none; stroke:var(--header-text-color-active); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 30 30"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="'/assets/images/notification-icon.svg#svg3108'" stroke-width="1px"  />
						</svg>
						<!-- <object v-html="commonSvgs.notification_popup"></object> -->
						<div v-if="navbarStore.notifications_dropdown" class="notifications-dropdown-main">
							<NotificationsDropdown v-if="navbarStore.notifications_dropdown"></NotificationsDropdown>
						</div>
					</div>

					<div class="setting-main" id="settings-dropdown">
						<svg @click="showSettings()" class="user-icons"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:22px; height: 25px; fill: none; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 25 25"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="'/assets/images/settings-icon.svg#svg3108'" stroke-width="1px"  />
						</svg>
						<!-- <object  v-html="svgs_data.setting_icon" @click="showSettings()"></object> -->
						<div v-if="navbarStore.settings_dropdown" class="setting-dropdown-main active">
							<setting-dropdown v-if="navbarStore.settings_dropdown"></setting-dropdown>
						</div>
					</div>

					<a href="#" class="login-search" @click="showSportsbookSearchModal($event)">
						<svg id="Icon_search" data-name="Icon search" xmlns="http://www.w3.org/2000/svg" width="18.707" height="18.707" viewBox="0 0 18.707 18.707">
							<g id="Path_3" data-name="Path 3" transform="translate(-2.25 -2.25)" fill="none" stroke-linecap="round" stroke-linejoin="round">
								<path d="M18.75,10.5A8.25,8.25,0,1,1,10.5,2.25a8.25,8.25,0,0,1,8.25,8.25Z" stroke="none" />
								<path d="M 10.50000190734863 17.75 C 14.49766159057617 17.75 17.75000190734863 14.49765968322754 17.75000190734863 10.5 C 17.75000190734863 6.502339839935303 14.49766159057617 3.25 10.50000190734863 3.25 C 6.502341747283936 3.25 3.250001907348633 6.502339839935303 3.250001907348633 10.5 C 3.250001907348633 14.49765968322754 6.502341747283936 17.75 10.50000190734863 17.75 M 10.50000190734863 18.75 C 5.943651676177979 18.75 2.250001907348633 15.0563497543335 2.250001907348633 10.5 C 2.250001907348633 5.943649768829346 5.943651676177979 2.25 10.50000190734863 2.25 C 15.05635166168213 2.25 18.75000190734863 5.943649768829346 18.75000190734863 10.5 C 18.75000190734863 15.0563497543335 15.05635166168213 18.75 10.50000190734863 18.75 Z" stroke="none" fill="var(--header-text-color-active)" />
							</g>
							<path id="Path_4" data-name="Path 4" d="M15.75,15.75l-3.262-3.262" transform="translate(2.25 2.25)" fill="none" stroke="var(--header-text-color-active)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
						</svg>
					</a>
				</div>
			</div>

			<template v-else>
				<div class="right-content rightNav-desktop" v-if="screenWidth > 767">
					<div class="header-icons">
						<LiveChatHeader/>
						<ThemeSwitcher v-if="showThemeSwitcher"></ThemeSwitcher>
						<a class="search-ico-tab" @click="showSportsbookSearchModal($event)">
							<svg xmlns="http://www.w3.org/2000/svg" width="25.207" height="25.207" viewBox="0 0 25.207 25.207">
								<g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-1.75 -1.75)">
									<path id="Path_3" data-name="Path 3" d="M24.75,13.5A11.25,11.25,0,1,1,13.5,2.25,11.25,11.25,0,0,1,24.75,13.5Z" transform="translate(0)" fill="none" stroke="var(--another-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
									<path id="Path_4" data-name="Path 4" d="M17.23,17.225l-4.743-4.737" transform="translate(9.02 9.025)" fill="none" stroke="var(--another-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
								</g>
							</svg>
						</a>

						<div class="setting-main" id="settings-dropdown">
							<object  v-html="svgs_data.setting_icon" @click="showSettings()"></object>
							<div v-if="navbarStore.settings_dropdown" class="setting-dropdown-main active">
								<setting-dropdown v-if="navbarStore.settings_dropdown"></setting-dropdown>
							</div>
						</div>
					</div>

					<div class="header-btn">
						<a @click="showLoginModal()" class="btn-small login">{{ $t('general.login') }}</a>
						<a v-if="agentStore.showRegisterModal" @click="showRegisterModal()" class="btn-small btn-secondary">{{ $t('general.register') }}</a>
					</div>
				</div>
			</template>

			<div class="right-content rightNav-tablet">
				<TabNav></TabNav>
			</div>
		</div>
	</header>
	<div class="platform_notification" v-if="customerStore.isLoggedIn && platform_notification.length > 0">
		<template v-for="notification in platform_notification" :key="notification.id">
			<PlatformNotification :notification="notification"></PlatformNotification>
		</template>
	</div>
</template>

<style scoped>
.notification-icon-area {
    top: 3px;
    left: 3px;
}
nav ul li a {
	color: var(--header-text-color);
}

li.active > a {
	color: var(--header-text-color-active);
}
svg.user-icons {
	stroke: var(--header-text-color-active);
}
.not-icon {
	width: 28px;
	height: 28px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	vertical-align: middle;
}

.profile-balance, .user-detail {
	color: var(--header-text-color-active);
}
/* .setting-icon {
	width: 28px;
	height: 28px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	vertical-align: middle;
} */
.dark-header a.btn-small.login {
	color: var(--header-text-color-active);
}
.dark-header a.btn-small.login:hover {
	color: var(--button-color-text-hover);
}

.profile-balance {
	color: var(--header-text-color);
}
@media screen and (min-width: 992px) and (max-width: 1056px) {
	.customer-username {
		display: none!important;
	}
}
.wallet-icon {
  color: var(--dark-gray);
}
.wallet-btn:hover .wallet-icon {
	color: var(--white);
	background-color: transparent;
}

.wallet-btn:hover {
	background-color: transparent;
	box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.wallet-btn {
	padding: 0;
	width: 35px;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.user-icon {
	display: block!important;
	width: 20px!important;
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.user-icon {
		display: none!important;
	}
}
/* mobile menu slide in */
.slide-fade-enter-active {
	transition: all 0.1s ease-out;
}
.slide-fade-leave-active {
	transition: all 0.1s ease-out;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
	transform: translateX(-20px);
}
html[dir="rtl"] .slide-fade-enter-from {
	transform: translateX(20px);
}
html[dir="rtl"] .slide-fade-leave-to {
	transform: translateX(20px);
}
html[dir="rtl"] .menu-mobile .nav-list {
	left:unset;
	right:0;
}
.menu-mobile .nav-list {
	box-shadow: 200px 0px 0px rgb(0 0 0 / 42%);
}
html[dir="rtl"] .menu-mobile .nav-list {
	box-shadow: -200px 0px 0px rgb(0 0 0 / 42%);
}
.menu-mobile ul {
	flex: 0 0 255px;
	display: block;
}
.first-menu {
	margin-bottom: 20px;
}
.second-menu {
	margin-bottom: 20px;
}
.third-menu {
	margin-bottom: 20px;
}
.bottom-menu {
	/* position: absolute; */
	/* bottom: 170px; */
	width: 215px;
}

a.basic-menu-font {
	font-weight: 400 !important;
	font-size:16px!important;
}
a.custom-font {
	font-family: Arial, sans-serif;
	font-weight: 800 !important;
	font-size: 16px !important;
	color:var(--off-gray) !important;
}
[dir="rtl"] a.custom-font {
	font-family: 'Roboto', sans-serif;
}
svg.svg-inline--fa.fa-comments.fa-w-18,
svg.svg-inline--fa.fa-download.fa-w-16 {
	margin-left: 10px;
}
html[dir="rtl"] svg.svg-inline--fa.fa-comments.fa-w-18{
	margin-left:unset;
	margin-right:10px;
}
html[dir="rtl"] svg.svg-inline--fa.fa-download.fa-w-16{
	margin-left:unset;
	margin-right:10px;
}
.menu-mobile .nav-list {
	row-gap: 20px;
}
nav ul li {
	display: block;
	line-height: 1.5;
	color: var(--light-gray);
	text-decoration: none;
	transition: .2s ease-in-out;
	font-size: 13px;
	font-weight: 300;
}
nav ul li ul li a {
	padding: 10px;
}
nav ul li a:hover {
	color: var(--header-text-color-active);
}
nav ul .dropdown-menu .active:after {
	content: "";
	width: 150px;
	height: 48%;
	position: absolute;
	bottom: 0px;
	left: 0;
	border-bottom: 2px solid var(--primary);
}
.menu-desktop .dropdown-menu {
	display: none;
	position: absolute;
	z-index: 1;
	background: var(--dark-gray);
	width: 150px;
	border-radius: 5px;
}
.menu-desktop .dropdown:hover .dropdown-menu,
.menu-desktop .dropdown-menu:hover {
	display: block;
}
header.Logged-in .header-inner .login-info .email-verification-icon .tooltip-main {
	display: none;
}
html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon .setting-main {
	flex-direction: row-reverse;
}

.header-inner-page .search-ico-tab {
	display: block;
	cursor: pointer;
}

header.Logged-in .header-inner .profile-balance {
	display: block;
}

.header-icon {
	display: grid;
	grid-template-columns: 30% 30% 30%;
	grid-gap: 10px;
}

.login-search {
	display: block !important;
}

header.Logged-in .header-inner .login-info .user-profile-top .user-detail p {
	font-size: 12px;
	width: 100px;
	overflow: hidden;
	text-wrap: nowrap;
	text-overflow: ellipsis;
	text-align: end;
}

/* header.Logged-in .header-inner .login-info .profile-balance h6 {
	font-size: 12px;
	width: 62px;
	overflow: hidden;
	text-wrap: nowrap;
	text-overflow: ellipsis;
} */


@media screen and (min-width: 320px) and (max-width: 767px) {
	header.Logged-in .header-inner .login-info {
		padding-left:8px!important;
	}
	header.Logged-in .header-inner .login-info .header-icon {
		gap:4px;
	}
}
@media screen and (min-width: 1327px) and (max-width: 1380px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 20px;
	}
	.email-verification-icon {
		/* margin-right: -10px; */
	}
}
@media screen and (min-width: 1282px) and (max-width: 1326px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 15px;
	}
	.email-verification-icon {
		/* margin-right: -10px; */
	}
}
@media screen and (min-width: 320px) and (max-width: 400px) {
	.email-verification-icon {
		margin-right: 12px;
	}
}
@media screen and (min-width: 1201px) and (max-width: 1281px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 10px;
	}
	.email-verification-icon {
		/* margin-right: -23px; */
	}
	header.Logged-in .logo-img {
		width: 110px;
	}
	header.Logged-in .header-left {
		gap:19px;
	}
}

@media screen and (min-width: 1160px) and (max-width: 1200px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 9px;
	}
	header.Logged-in nav ul li a {
		font-size: 13px;
	}
	header.Logged-in .logo-img {
		width: 110px;
	}
	.email-verification-icon {
		/* margin-right: -20px; */
	}
	header.Logged-in .header-left {
		gap:12px;
	}
}
@media screen and (min-width: 1125px) and (max-width: 1159px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 10px;
	}
	header.Logged-in nav ul li a {
		font-size: 13px;
	}
	header.Logged-in .logo-img {
		width: 100px;
	}
	header.Logged-in .btn-small {
		width: 80px;
		padding: 5px;
	}
	.email-verification-icon {
		/* margin-right: -20px; */
	}
}
@media screen and (min-width: 1084px) and (max-width: 1124px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 9px!important;
	}
	header.Logged-in nav ul li a {
		font-size: 12px;
	}
	header.Logged-in .logo-img {
		width: 100px;
	}
	header.Logged-in .btn-small {
		width: 80px;
		padding: 5px;
	}
	header.Logged-in .header-left {
		gap: 15px;
	}
}
@media screen and (min-width: 1056px) and (max-width: 1083px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 9px!important;
	}
	header.Logged-in nav ul li a {
		font-size: 12px;
	}
	header.Logged-in .logo-img {
		width: 90px;
	}
	header.Logged-in .btn-small {
		width: 70px;
		padding: 5px;
	}
	header.Logged-in .header-left {
		gap: 10px;
	}
}

@media screen and (min-width: 992px) and (max-width: 1055px) {
	header.Logged-in .header-left .menu-desktop ul.nav-list {
		gap: 10px!important;
	}
	header.Logged-in nav ul li a {
		font-size: 13px;
	}
	header.Logged-in .logo-img {
		width: 80px;
	}
	header.Logged-in .btn-small {
		width: 70px;
		padding: 5px;
	}
	header.Logged-in .header-left {
		gap: 10px;
	}
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.icon.desktop-only{
		display:none!important;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] .login-info .header-icon .notifications-main .notifications-dropdown-main {
		right:unset!important;
		left:0px!important;
	}
}
@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] .login-info .header-icon .notifications-main .notifications-dropdown-main {
		right:unset!important;
		left:1px!important;
	}
}
@media screen and (min-width: 768px) and (max-width: 2000px) {
	header.Logged-in .header-inner .login-info .header-icon a svg {
		padding-top: 7px!important;
	}
}

@media screen and (min-width: 320px) {
	header.Logged-in .header-inner .login-info .user-profile-top .user-detail p {
		width: 20px;
	}
}

@media screen and (min-width: 375px) and (max-width: 424px) {
	header.Logged-in .header-inner .login-info .user-profile-top .user-detail p {
		width: 50px;
	}
}

@media screen and (min-width: 425px) and (max-width: 767px) {
	header.Logged-in .header-inner .login-info .user-profile-top .user-detail p {
		width: 50px;
	}

}

@media screen and (min-width: 768px) {
	header.Logged-in .header-inner .login-info .user-profile-top .user-detail p {
		width: 80px;
	}
}
@media screen and (min-width: 1281px) and (max-width: 3000px) {
	header.Logged-in .header-inner .login-info .user-profile-top.active :deep(.user-dropdown-info) {
			background: var(--dark);
			padding: 20px 20px 19px 20px!important;
			width: 264px;
			position: absolute;
			right: -36px;
			top: 37px;
			display: block;
			border-radius: 0 0 5px 5px;
			box-shadow: 5px 10px 15px rgba(19, 23, 29, 0.25);
	}
}
@media screen and (min-width: 992px) and (max-width: 1280px) {
	header.Logged-in .header-inner .login-info .user-profile-top.active :deep(.user-dropdown-info) {
		top: 39px;
		right: -210px;
		padding: 20px 20px 19px 20px;
	}
	html[dir="rtl"] header.Logged-in .header-inner .login-info .user-profile-top.active :deep(.user-dropdown-info) {
		top: 38.5px;
		right: -30px;
		padding: 20px 20px 19px 20px;
	}
}
@media screen and (min-width: 768px) and (max-width: 991px) {
	header.Logged-in .header-inner .login-info .user-profile-top.active :deep(.user-dropdown-info) {
		top: 38.5px;
		right: -200px;
		padding: 20px 20px 19px 20px;
	}
	html[dir="rtl"] header.Logged-in .header-inner .login-info .user-profile-top.active :deep(.user-dropdown-info) {
		top: 38.5px;
		right: -50px;
		padding: 20px 20px 19px 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	header.Logged-in .header-inner .login-info .user-profile-top.active :deep(.user-dropdown-info) {
		padding: 18px 24px 19px 24px;
		width: 100%;
		right: 0;
		top: 51px;
		left: 0;
		z-index: 32;
	}
}


@media screen and (min-width: 992px) and (max-width: 1040px) {
	.header-inner-page .header-left {
		gap: 15px;
	}
	/* header.Logged-in .header-inner .login-info {
		gap: 25px;
	} */
}

@media screen and (min-width: 992px) and (max-width: 1001px) {
	html[dir="rtl"] .header-inner-page .nav-list {
		gap: 12px;
	}
}

@media screen and (min-width: 1041px) and (max-width: 1047px) {
	html[dir="rtl"] .header-inner-page .nav-list {
		gap: 12px;
	}
}

@media screen and (min-width: 320px) and (max-width: 344px){
	header.Logged-in .header-inner .login-info .user-profile-top.active .user-detail:before {
		content: "";
		position: absolute;
		background: var(--dark);
		width: 55px;
	}

}
@media screen and (min-width: 768px) and (max-width: 3000px) {
	html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon {
		border-left: unset !important;
		border-right: 1px solid var(--tab-gray) !important;
	}
}
@media screen and (min-width: 1281px) and (max-width: 3000px) {
	html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon .login-search {
		display: block;
		padding-right: 10px;
	}
}
@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon .setting-main {
		padding-right: 10px
	}
}
html[dir="rtl"] header.Logged-in .header-inner .login-info .user-profile-top .user-detail svg {
	right: unset;
	left: -20px;
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] header.Logged-in .header-inner .login-info .user-profile-top .user-detail svg {
		right: unset;
		left: unset;
	}
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon .setting-main .setting-dropdown-main {
		top: 37px;
		right: -240px!important;
	}
}
@media screen and (min-width: 1281px) and (max-width: 3000px) {
	html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon .setting-main .setting-dropdown-main {
			right: unset;
			left: 1px;
			top: 57px;
	}
}
@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon .setting-main .setting-dropdown-main {
			right: unset;
			left: -20px;
			top: 60px;
	}
}

.right-content .header-icons .setting-main .setting-dropdown-main {
	background: var(--dark-gray);
	position: absolute;
	width: 260px;
	max-width: min(260px, calc(100vw - 24px));
	inset-inline-end: 0;
	inset-inline-start: auto;
	padding: 30px 20px 20px;
	box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
	display: block;
	cursor: pointer;
}
@media screen and (min-width: 768px) and (max-width: 1280px) {
	header.Logged-in .header-inner .login-info .header-icon .setting-main .setting-dropdown-main {
		top: 60px;
	}

	.login-info  .header-icon .notifications-main .notifications-dropdown-main {
		top: 45px !important;
		right: 1px !important;
	}

	header.Logged-in .header-inner .login-info .header-icon {
		flex-direction: unset !important;
	}
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	header.Logged-in .header-inner .login-info .header-icon .setting-main .setting-dropdown-main {
		right: -30px!important;
	}

	.login-info  .header-icon .notifications-main .notifications-dropdown-main {
		right: 0px!important;
		top: 57px !important;
	}

}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.right-content .header-icons .setting-main .setting-dropdown-main {
		top: 37px;
		padding: 15px;
		/* right: -10px; */
	}

	.login-info  .header-icon .notifications-main .notifications-dropdown-main {
		top: 37px;
		padding: 15px;
		/* right: -10px; */
	}

	header.Logged-in .header-inner .login-info {
		gap: 12px !important;
	}
}
@media screen and (max-width: 1281px){
	.header-inner-page .nav-list {
		gap: 15px;
	}
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	header.Logged-in .header-inner .login-info .header-icon .setting-main .setting-dropdown-main {
		/* right: -10px; */
		top: 37px;
	}

	.login-info  .header-icon .notifications-main object {
		/* right: -10px; */
		padding-top: 4px !important;
	}

	.login-info  .header-icon .login-search svg {
		/* right: -10px; */
		padding-top: 5px !important;
	}
}
@media screen and (min-width: 768px) and (max-width: 3000px) {
	header.Logged-in .header-inner .login-info .header-icon .setting-main .setting-dropdown-main {
		right:0px;
	}

	.login-info  .header-icon .notifications-main .notifications-dropdown-main {
		right:0px;
	}
}


@media screen and (min-width: 1281px) and (max-width: 3000px) {
	.login-info  .header-icon .notifications-main .notifications-dropdown-main {
		top: 45px !important;
		right: -80px !important;
	}

	html[dir="rtl"] .login-info  .header-icon .notifications-main .notifications-dropdown-main {
		top: 45px !important;
		right: -175px !important;
	}
}

header.Logged-in .header-inner .login-info .header-icon a {
	padding-top: 0px !important;
}
/*
@media screen and (min-width: 320px) and (max-width: 767px) {
	header.Logged-in .header-inner .login-info .header-icon {
		align-items: center;
	}
} */

.login-info  .header-icon .notifications-main .notifications-dropdown-main {
	background: var(--dark-gray);
	position: absolute;
	top: 40px;
	width: 300px;
	right: -83px;
	padding: 30px 20px 20px;
	/* border-radius: 5px; */
	box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
	display: block;
	cursor: pointer;
	color: aliceblue;
}

@media screen and (min-width: 320px) and (max-width: 400px) {
	header.Logged-in .header-inner :deep(.login-info) {
		gap: 4px !important;
		padding-left: 4px !important;
	}
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	header.Logged-in .header-inner .login-info .header-icon a svg {
		width: 26px !important;
		height: 23px !important;
		margin-top: 5px !important;
	}
}

.notification-num {
	position: absolute;
	top: 13px;
	right: -5px;
	background: var(--red);
	color: white;
	font-size: 10px;
	padding: 0px 0px;
	border-radius: 2px;
	line-height: 1;
	width: 13px;
	height: 13px;
	text-align: center;
}

html[dir="rtl"] .notification-num {
	right: unset;
	left: -5px;
}

/* SHARE CODE */
.disabled {
	pointer-events: none;
}

.text-field {
	position: relative;
}

.clear-button {
	position: absolute;
	top: 50%;
	right: 8px;
	transform: translate(-50%, -50%);
	cursor: pointer;
	width: 14px;
	color: var(--off-light-gray);
}

html[dir="rtl"] .clear-button {
	left: 16px;
	right: unset;
}

.share-btn {
	background: var(--secondary);
	color: var(--dark-gray);
	border: 1px solid transparent;
	height: 30px;
	transition: 0.3s ease-in-out;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
	font-weight: 500;
	text-decoration: none;
	display: inline-block;
	text-align: center;
	transition: 0.3s ease-in-out;
	padding: 0px 5px 3px 5px;
	width: 100%;
	text-wrap: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-top: 10px;
}

.share-btn:hover {
	border: 1px solid var(--light-gray);
	background: var(--dark);
	color: var(--white);
}

.btn-disabled {
	border: 1px solid var(--light-gray);
	background: var(--dark);
	color: var(--white);
	pointer-events: none;
}

.form-input {
	width: 100%;
	padding: 5px 40px 5px 15px;
	background-color: var(--light-dark);
	border-radius: 3px;
	font-size: 14px;
	font-weight: 300;
	color: var(--off-light-gray);
}

html[dir="rtl"] .form-input {
	padding: 5px 15px 5px 40px;
}

.header-mobile-icon {
	width: 24px;
	height: 23px;
	margin-right: 5px;
}

.icon {
	display: flex !important;
	align-items: flex-end !important;
}

.icon a:after {
	content: unset!important;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.notification-num {
		position: absolute;
		top: 13px;
		right: 55px;
		font-size: 9px;
		width: 10px;
		height: 10px;
	}

	html[dir="rtl"] .notification-num {
		right: unset;
		left: 80px;
	}
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.notification-num {
		right: 80px;
	}

	html[dir="rtl"] .notification-num {
		right: unset;
		left: 140px;
	}
}

@media screen and (min-width: 992px) and (max-width: 1055px) {
	.notification-num {
		right: 75px;
		font-size: 9px;
		width: 10px;
		height: 10px;
	}

	html[dir="rtl"] .notification-num {
		right: unset;
		left: 95px;
	}
}

@media screen and (min-width: 1056px) and (max-width: 1280px) {
	.notification-num {
		right: 80px;
	}

	html[dir="rtl"] .notification-num {
		right: unset;
		left: 135px;
	}
}

html[dir="rtl"] header.Logged-in .header-inner .login-info .header-icon a {
	padding-right: 10px;
}

.btn-glowing-border {
	position: relative;
	overflow: hidden;
	z-index: 1;
	background: transparent !important;
	border: none !important;
	transition: box-shadow 0.3s ease;
}

.btn-glowing-border:hover {
	box-shadow: 0 0 20px color-mix(in srgb, var(--secondary) 80%, transparent);
	color: var(--white) !important;
}

.btn-glowing-border::before {
	content: '';
	position: absolute;
	top: -150%;
	left: -150%;
	width: 400%;
	height: 400%;
	background: conic-gradient(
		from 0deg,
		transparent 0%,
		transparent 30%,
		var(--secondary) 45%,
		var(--white) 50%,
		transparent 55%,
		transparent 70%,
		transparent 100%
	);
	animation: rotate-border 2.5s linear infinite;
	z-index: -2;
}

.btn-glowing-border::after {
	content: '';
	position: absolute;
	inset: 1.5px;
	background: var(--secondary);
	border-radius: 3px;
	z-index: -1;
	transition: background-color 0.3s ease;
}

.btn-glowing-border:hover::after {
	background: var(--dark);
}

@keyframes rotate-border {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>